import { checkRights } from '@crm-framework/auth';

import { USER_RIGHTS } from '@crm-package/auth';

export const checkDownloadWithEmail = (state): boolean =>
  checkRights(state, [USER_RIGHTS.EXCEL_VIEW_EMAIL, USER_RIGHTS.EXPORT]);

export const getExcelValue = (payload): number => {
  if (payload?.withPhone && payload?.withEmail) return 3;

  if (payload?.withPhone) return 1;

  if (payload?.withEmail) return 2;

  return 0;
};
